import { useFieldArray, useFormContext } from 'react-hook-form';
import { BoolRadioField } from '@views/register/history/history-fields';
import type { TLocalize } from '@hooks/use-localize';
import type { IHistoryMiscFormValues } from '@/types/history/history-misc';
import FieldError from '@components/field-error';

interface IProps {
    t: TLocalize;
}

const AllergiesSection = ({ t }: IProps) => {
    const {
        control,
        register,
        watch,
        formState: { errors },
    } = useFormContext<IHistoryMiscFormValues>();
    const { fields, append, remove } = useFieldArray({ control, name: 'allergies' });

    const allergy = t('DashWord_Allery', 'Allergy');
    const deleteAllergy = t('DashLabel_DeleteAllergy', 'Delete allergy');

    return (
        <>
            <BoolRadioField
                name="hasAllergies"
                label={t('DashLabel_DoYouHaveAnyAllergies', 'Do you have any allergies')}
                yesLabel={t('Word_Yes', 'Yes')}
                noLabel={t('Word_No', 'No')}
            />

            {watch('hasAllergies') === '1' && (
                <div className="sub-question">
                    <div className="form-group">
                        <div className="col-xs-12">
                            <div className="help-block">
                                {t('DashLabel_PleaseListYourAllergies', 'Please list your allergies')}
                                <FieldError message={errors.allergies?.root?.message ?? errors.allergies?.message} />
                            </div>

                            {fields.map((field, index) => (
                                <div className="row row-margined" key={field.id}>
                                    <div className="col-xs-12 col-sm-6">
                                        <input
                                            className="form-control"
                                            placeholder={allergy}
                                            {...register(`allergies.${index}.name`)}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-1">
                                        {index > 0 && (
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-delete-entry"
                                                aria-label={deleteAllergy}
                                                title={deleteAllergy}
                                                onClick={() => remove(index)}
                                            >
                                                <span className="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}

                            <div className="row">
                                <div className="col-xs-12">
                                    <button
                                        type="button"
                                        className="btn btn-add-entry btn-sm"
                                        style={{ width: 150 }}
                                        onClick={() => append({ name: '' })}
                                    >
                                        <span className="glyphicon glyphicon-plus-sign"></span>{' '}
                                        {t('DashLabel_AddAllergy', 'Add Allergy')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AllergiesSection;
